import { useQuery } from '@tanstack/react-query';
import { AxiosError, AxiosResponse } from 'axios';
import { SHARE_LINKS_KEY } from '~/queries/keys';
import shareLinkApi from '~/shareLinkApi';
import { mapShareLinkFromApiToVm } from '~/shareLinkApi/shareLink.mappers';
import { IShareLinkMapped } from '~/shareLinkApi/shareLink.model';

interface UseGetShareLinkProps {
  sharedToken: string;
  params?: {
    show_owners?: boolean;
  };
}
export const useGetShareLink = ({
  sharedToken,
  params = {},
}: UseGetShareLinkProps) => {
  return useQuery<AxiosResponse, AxiosError, IShareLinkMapped, any>({
    queryKey: [SHARE_LINKS_KEY, { sharedToken }],
    queryFn: async () => {
      return shareLinkApi
        .get(`share-links/${sharedToken}`, { params })
        .then(({ data }) => mapShareLinkFromApiToVm(data));
    },
    enabled: Boolean(sharedToken),
  });
};
